import { useStore, CAT_META } from "../store/Store";

// ─── ARRIVAL CARD ─────────────────────────────────────────────────────────────
// Tiny, minimal card for the stacked "New Arrivals" sub-rows (Ethnic Edit,
// Western Edit, Accessorize...). No colored background, no add-to-cart
// button — just a clean full (uncropped) photo + name + discount, matching
// the reference's plain "arrival-card" density.
export default function ArrivalCard({ p, onNav }) {
  const meta = CAT_META[p.category] || { emoji:"👗" };
  const disc = Math.round((1 - p.price / p.mrp) * 100);

  return (
    <div onClick={()=>onNav("product", p.id)} style={{ cursor:"pointer" }}>
      <div style={{ height:170, borderRadius:10, overflow:"hidden", background:meta.light||"#eef3f6", display:"flex", alignItems:"center", justifyContent:"center" }}>
        {p.img
          ? <img src={p.img} alt={p.name} style={{ width:"100%", height:"100%", objectFit:"contain" }} loading="lazy"/>
          : <div style={{ fontSize:34, opacity:0.25 }}>{meta.emoji}</div>
        }
      </div>
      <div style={{ paddingTop:7, fontSize:12 }}>
        <div style={{ fontWeight:700, color:"#1a1a2e", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{p.name}</div>
        <div style={{ fontWeight:700, color:"#EC4899", fontSize:11, marginTop:2 }}>
          {disc>0 ? `Min. ${disc}% Off` : `₹${p.price?.toLocaleString("en-IN")}`}
        </div>
      </div>
    </div>
  );
}
